import React from "react";
import { Link } from "react-router-dom";
import { CONTRACT_ADDRESS } from "../../../../constants/tokens";
import { FileTextOutlined } from "@ant-design/icons";

export default function AddressLink({ children, address }) {
  switch (address) {
    case CONTRACT_ADDRESS.rise:
      return (
        <Link
          to={`/contract/${address}`}
          style={{ display: "flex", alignItems: "center" }}
        >
          <FileTextOutlined />
          &nbsp;
          {children}
        </Link>
      );
    case CONTRACT_ADDRESS.cash: {
      return (
        <Link
          to={`/contract/${address}`}
          style={{ display: "flex", alignItems: "center" }}
        >
          <FileTextOutlined />
          &nbsp;
          {children}
        </Link>
      );
    }
    default:
      return <Link to={`/account/${address}`}>{children}</Link>;
  }
}
